<section aria-labelledby="section-title">
  <div class="row">
    <div class="col-sm-10 col-md-8 col-lg-6 mx-auto text-center">
      <h1 id="section-title" *ngIf="errorMessage">{{errorTitle}}</h1>
      <p *ngIf="errorMessage" [innerHTML]="errorMessage"></p>
      <div class="mt-50">
        <small>
          <span *ngIf="errorCode">EC: {{errorCode}}</span>
          <br>
          <span *ngIf="sessionId">SID: {{sessionId}}</span>
          <br>
          <span *ngIf="version">VERSION: {{version}}</span>
        </small>
      </div>
    </div>
  </div>
</section>
